import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Domain } from 'models';
import { usePermissions } from 'models/user/permissions';

import { Button, Icon, Message, Status, WeezHeader } from '@weezevent/nacre';

import { ActiveDomains, InactiveDomains } from './components';

import { DOMAIN_STATUS } from '../emails.constants';

import css from '../emails.module.css';

export const DomainInformation = ({ domainName }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const permissions = usePermissions();

    const [openModal, setOpenModal] = React.useState(false);
    const [domain, , sync] = Domain.useApiModel(
        {
            id: domainName,
            cache: false,
            allow_cache: false
        },
        [domainName]
    );

    const { type, statusKey, statusColor } = DOMAIN_STATUS[domain?.verification_status] ?? {};
    return (
        domain && (
            <>
                <WeezHeader
                    rightComponent={[
                        permissions.isAdmin() && domain.is_success ? (
                            <Button key={0} primary onClick={() => setOpenModal(true)} icon={<Icon name="plus" />} label={t('sauron.emails.domains.add-organization')} />
                        ) : null
                    ]}
                    leftComponent={[]}
                    title={
                        <div className={css['header-title-container']}>
                            <div className={css['header-button']}>
                                <Button className={css['header-icon']} icon={<Icon name="at" size="huge" />} onClick={() => history.push('/emails/domains')} />
                            </div>
                            {domain.name}
                            <Status color={statusColor} text={t(`sauron.emails.domains.status.${statusKey}`)} />
                        </div>
                    }
                />
                {type && (
                    <Message type={type} title={t(`sauron.emails.domains.domain-info.message.title.${statusKey}`)}>
                        {t(`sauron.emails.domains.domain-info.message.description.${statusKey}`)}
                    </Message>
                )}
                {domain.is_success ? <ActiveDomains domain={domain} openModal={openModal} setOpenModal={setOpenModal} syncDomain={sync} /> : <InactiveDomains domain={domain} />}
            </>
        )
    );
};
